// extracted by mini-css-extract-plugin
export default {"menu_container":"MenuTabs_menu_container__Dq1kt","menu":"MenuTabs_menu__wlg3h"};